import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react'
import styled from '@emotion/styled'

const GalleryContainer = styled.div`
  padding-bottom: 16px;
`

const Gallery = styled.div`
  max-width: 100vw;
  overflow-x: scroll;
  padding-bottom: 16px;
`

const scrollAnimation = `
  @keyframes scroll {
    0% {
      margin-left: var(--scroll-start);
    }
    100% {
      margin-left: var(--scroll-end);
    }
  }
`;

const ImageContainer = styled.div`
  display: flex;
  gap: 16px;
  animation: scroll 30s linear infinite;
  ${scrollAnimation}
  
  --scroll-start: -15vw;
  --scroll-end: -150vw;
  
  @media (max-width: 768px) {
    --scroll-start: -175px;
    --scroll-end: -1750px;
  }
`

const Image = styled(GatsbyImage)`
  max-height: 70vh;
  width: max(30vw, 350px);
  object-fit: cover;
`

const ImageGallery = ({data}) => {
  return ( 
    <GalleryContainer>
      <Gallery>
        <ImageContainer>
          {
            data?.GalImages?.map(image => {
              return (
                <div>
                  <Image image={getImage(image?.file.childImageSharp.gatsbyImageData)} />
                </div>
              )
            })
          }
        </ImageContainer>
      </Gallery>
    </GalleryContainer>
  );
}
 
export default ImageGallery;